import http, { url } from '../../../http'

const API_URL = "activity-schedule" 

class ActivityScheduleAPI {

  // CRUD functions

  async save(plan) {
    const response = await http(`${API_URL}/save`, 'POST', plan)
    return response
  }

  async getAll(companyID) {
    const response = await http(`${API_URL}/show-exercises/${companyID}`)
    return response || null
  } 

  async get(planID) {
    const response = await http(`${API_URL}/${planID}`)
    return response || null
  }

  print(companyID) {
    return url(`${API_URL}/downloadpdf/${companyID}`)
  }
    
}

export default new ActivityScheduleAPI()